import { FEEDBACK_FORM_TYPE } from 'constants/ProjectConstants';
import { pushFeedbackParams } from 'constants/helper';

import { CF_TABLE_META_CELLS } from '../constants';

export const columnToCellMetaMapper = ({ id, uuidType, displayName, type, hideViewFullComment }) =>
  CF_TABLE_META_CELLS[uuidType]({ id, uuidType, displayName, type, hideViewFullComment });

export const openFeedbackSidePanel = ({ history, typeMapped = true, feedbackId, source, selectedFeedbackView }) => {
  pushFeedbackParams({
    history,
    formType: FEEDBACK_FORM_TYPE.PROVIDING_REQUESTED,
    typeMapped,
    feedbackId,
    source,
    selectedFeedbackView,
  });
};
